import "./Answer.scss"
import { t } from "i18next"
import { AnswerDto } from "../../../checklist/model/ChecklistDtos"
import { useEffect, useState } from "react"
import { Const } from "../../../../core/const/const"
import { QuestionAnswerDto } from "../../model/qualityCheckDtos"
import { useModal } from "../../../../core/common/modal/ModalContext"
import { Card, IconButtonArrow, Row } from "../../../../core/components"

interface AnswerProps {
    answer: QuestionAnswerDto
}

export default function Answer({ answer }: AnswerProps) {
    const [image, setImage] = useState<string | null>(null)
    const [isExpandable, setIsExpandable] = useState<boolean>(false)
    const [isExpanded, setIsExpanded] = useState(false)
    const modal = useModal()

    useEffect(() => {
        const base64 = answer.answer?.photoFileData
        if (!base64) return

        const binaryString = atob(base64)
        const bytes = new Uint8Array(binaryString.length)
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i)
        }

        const blob = new Blob([bytes], { type: "image/jpeg" })
        const url = URL.createObjectURL(blob)
        setImage(url)

        if (url)
            setIsExpanded(true)

        return () => {
            URL.revokeObjectURL(url)
        }
    }, [answer.answer?.photoFileData])

    const toggleExpand = () => setIsExpanded(!isExpanded)

    const getAnswer = (answer?: AnswerDto) => {
        if (answer?.answerBoolean != null) {
            return answer.answerBoolean ? t("Yes") : t("No")
        }

        if (answer?.answerNumber != null) {
            return answer.answerNumber
        }

        if (answer?.answerText != null) {
            return answer.answerText
        }

        return t("No answer provided")
    }

    useEffect(() => {
        if (image)
            setIsExpandable(true)
        else
            setIsExpandable(false)
    }, [image])

    const openPhotoInModal = () => {
        if (!image)
            return

        modal.openModal(
            <div style={{ textAlign: "center", height: "100%", width: "100%" }}>
                <img
                    src={image}
                    alt=""
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover", marginBottom: "-4px" }}
                />
            </div>,
            false
        )

    }

    return (
        <Card padding={"05"} margin={"0"}>
            <Row alignItems="center">
                <div className="question-value" style={{width: "50%"}}>
                    {answer.question.description}
                </div>
                <div className="answer-value">
                    {getAnswer(answer.answer)}
                </div>

                {isExpandable && <Row.End alignSelf="flex-start">
                    <IconButtonArrow size="small" direction={isExpanded ? "up" : "down"} onClick={toggleExpand} />
                </Row.End>}
            </Row>

            <div className={`expandable-container ${isExpanded ? "expanded" : ""}`}>
                <Row>
                    {image && <div style={{ width:200, height: 200, marginTop: 10, padding: 0, borderRadius: Const.borderRadiusSmall, overflow: "hidden" }}>
                        <img
                            src={image}
                            alt=""
                            style={{ width: 200, height: 200, objectFit: "cover", cursor: "pointer" }}
                            onClick={() => openPhotoInModal()}
                        />
                    </div>}
                </Row>
            </div>
            {/* )} */}
        </Card>
    )
}
